import type { EventFile } from './database';

export const EVENT_FILE_BUCKET = 'event_files';
export const EVENT_FILE_MAX_COUNT = 5;
export const EVENT_FILE_MAX_SIZE_BYTES = 10 * 1024 * 1024;
export const EVENT_FILE_SIGNED_URL_EXPIRES_SECONDS = 5 * 60;

export type EventFileDraft = {
  id: string;
  file: File;
  displayTitle: string;
  originalFilename: string;
  sizeBytes: number;
  targetOccurrenceIndexes: number[];
  error?: string;
};

export type EventFileFormItem = {
  id: string;
  kind: 'existing' | 'draft';
  displayTitle: string;
  originalFilename: string;
  sizeBytes: number;
  targetOccurrenceIndexes: number[];
  file?: File;
  storagePath?: string;
  error?: string;
  markedForDeletion?: boolean;
};

export type EventFilesSyncInput = {
  eventId: number;
  files: EventFileFormItem[];
  uploadedByUserId: string;
};

export type EventFileCountMap = Map<number, number>;

export type EventFileListProps = {
  files: EventFile[];
  isLoading?: boolean;
  isOpeningId?: string | null;
  onOpenFile: (file: EventFile) => void;
};

export type EventMaterialsFormSectionProps = {
  files: EventFileFormItem[];
  recurrenceCount: number;
  isRecurringCreate: boolean;
  isLoading?: boolean;
  errors?: string[];
  onAddFiles: (files: FileList | File[]) => void;
  onTitleChange: (id: string, value: string) => void;
  onRemove: (id: string) => void;
  onRestore?: (id: string) => void;
  onToggleOccurrence: (id: string, occurrenceIndex: number) => void;
};
